import { Save01Icon } from '@langchain/untitled-ui-icons';
import { Modal, ModalClose, ModalDialog } from '@mui/joy';

import { FC, ReactNode } from 'react';

import { Button, Tooltip } from '@/design-system';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  onDiscard?: () => void;
  title: string;
  description: string;
  saveCopy?: string | ReactNode;
  discardCopy?: string;
  children?: ReactNode;
  disabledSaveTooltip?: string;
};

const SaveConfirmationModal: FC<TProps> = ({
  isOpen,
  onClose,
  onConfirm,
  onDiscard,
  title,
  description,
  saveCopy = 'Save',
  discardCopy = 'Discard',
  disabledSaveTooltip,
  children,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalDialog
        style={{
          width: '500px',
        }}
      >
        <div className="flex flex-row items-start">
          <div className="rounded-full bg-brand-secondary p-3">
            <Save01Icon className="h-4.5 w-4.5 text-brand-secondary" />
          </div>
          <div className="ml-4 flex flex-col gap-1">
            <span className="text-lg font-semibold">{title}</span>
            <span className="text-sm text-tertiary">{description}</span>
            {children}
          </div>
          <ModalClose />
        </div>
        <div className="ml-auto mt-6 flex flex-row gap-2">
          <Button
            data-testid="save-confirmation-modal-cancel-button"
            color="primary"
            variant="plain"
            onClick={onClose}
          >
            Cancel
          </Button>
          {onDiscard && (
            <Button
              data-testid="save-confirmation-modal-discard-button"
              color="error"
              variant="outlined"
              onClick={onDiscard}
            >
              {discardCopy}
            </Button>
          )}

          <Tooltip title={disabledSaveTooltip}>
            <div>
              <Button
                data-testid="save-confirmation-modal-save-button"
                color="primary"
                disabled={!!disabledSaveTooltip}
                onClick={async () => {
                  await onConfirm();
                  onClose();
                }}
              >
                {saveCopy}
              </Button>
            </div>
          </Tooltip>
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default SaveConfirmationModal;
